<template>
    <div class="box" :style="{ '--width': width }">
      <div class="title">{{ $t(`event.activity.text_6`) }} <span v-if="title === '比赛数据' && sportType === '篮球'" @click="basketball">{{ $t('event.activity.text_5') }}</span></div>
      <div style="margin-left: 15px;" class="data-box">
        <div class="table-title">
          <div class="name">{{ name }}</div>
          <div style="color: #000;" v-for="item in data" :key="item.id">
            <span class="overflow-text" style="max-width: 80px;">{{ item.name }}</span>
            <span v-if="title !== '比赛数据'"> / {{ item.number }}</span>
          </div>
        </div>
        <div class="code">
          <div style="display: flex;">
            <div class="code-title" v-for="(item,i) in matchesType[code]" :key="item.value" v-show="isLength(i) || item.value === 'total'">
              <span v-if="item.val">{{ item.val }}</span>
              <span v-if="item.val2">{{ item.val2 }}</span>
              <span v-if="item.val3">{{ item.val3 }}</span>
            </div>
          </div>
          <div class="for-data" v-for="item in data" :key="item.id">
            <div v-show="isLength(i) || game.value === 'total'" v-for="(game,i) in matchesType[code]" :key="game.value">{{ item.stats[game.value] == -1 ? '' : item.stats[game.value] }}</div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    name: String,
    gameId: String,
    width: {
      type: String,
      default: '86px'
    },
    code: String,
    title: {
      type: String,
      default: '比赛数据'
    },
    sportType: {
      type: String,
      default: '篮球'
    }
  },
  data() {
    return {
      matchesType: {
        rugby: [
          {
            val: '传球',
            val2: '达阵',
            val3: 'PaTD',
            value: 'passingTD'
          },
          {
            val: '跑球',
            val2: '达阵',
            val3: 'RshTD',
            value: 'rushingTD'
          },
          {
            val: '传球',
            val2: '码数',
            val3: 'PaYds',
            value: 'passingYds'
          },
          {
            val: '跑球',
            val2: '码数',
            val3: 'RshYds',
            value: 'rushingYds'
          },
          {
            val: '抄截',
            val2: 'Int',
            value: 'interception'
          },
          {
            val: '拔旗',
            val2: 'Flag Pull',
            value: 'flagPulling'
          },
          {
            val: '擒杀',
            val2: 'Sack',
            value: 'sacks'
          }
        ],
        playerDate: [
          {
            val: '传球',
            val2: '达阵',
            val3: 'PaTD',
            value: 'passingTD'
          },
          {
            val: '接球',
            val2: '达阵',
            val3: 'RecTD',
            value: 'receivingTD'
          },
          {
            val: '跑球',
            val2: '达阵',
            val3: 'RshTD',
            value: 'rushingTD'
          },
          {
            val: '传球',
            val2: '码数',
            val3: 'PaYds',
            value: 'passingYds'
          },
          {
            val: '接球',
            val2: '码数',
            val3: 'RecYds',
            value: 'receivingYds'
          },
          {
            val: '跑球',
            val2: '码数',
            val3: 'RshYds',
            value: 'rushingYds'
          },
          {
            val: '抄截',
            val2: 'Int',
            value: 'interception'
          },
          {
            val: '拔旗',
            val2: 'Flag Pull',
            value: 'flagPulling'
          },
          // {
          //   val: '擒抱',
          //   val2: 'Tackle'
          // },
          {
            val: '擒杀',
            val2: 'Sack',
            value: 'sacks'
          }
        ],
        football: [
          { label: '比分', val: 'score' },
          { label: '控球率', val: 'ballPossessionRatio' },
          { label: '射门', val: 'shoot' },
          { label: '射正', val: 'onTarget' },
          { label: '射正率', val: 'onTargetRatio' },
          { label: '前场任意球', val: 'frontFieldFreeKick' },
          { label: '角球', val: 'conner' },
          { label: '关键传球', val: 'keyPass' },
          { label: '过人成功', val: 'dribblePast' },
          { label: '越位', val: 'offside' },
          { label: '犯规', val: 'foul' },
          { label: '红牌', val: 'redCard' },
          { label: '黄牌', val: 'yellowCard' },
          { label: '抢断', val: 'intercept' },
        ],
        basketball: [
          {
            val: '1st',
            value: '0'
          },
          {
            val: '2nd',
            value: '1'
          },
          {
            val: '3rd',
            value: '2'
          },
          {
            val: '4th',
            value: '3'
          },
          {
            val: '5th',
            value: '4'
          },
          {
            val: '6th',
            value: '5'
          },
          {
            val: '7th',
            value: '6'
          },
          {
            val: '8th',
            value: '7'
          },
          {
            val: '9th',
            value: '8'
          },
          {
            val: '10th',
            value: '9'
          },
          {
            val: this.$t('event.activity.text_8'),
            value: 'total'
          }
        ],
        volleyball: [
          {
            val: '第1局',
            value: '0'
          },
          {
            val: '第2局',
            value: '1'
          },
          {
            val: '第3局',
            value: '2'
          },
          {
            val: '第4局',
            value: '3'
          },
          {
            val: '第5局',
            value: '4'
          },
          {
            val: '第6局',
            value: '5'
          },
          {
            val: '第6局',
            value: '6'
          },
          {
            val: '第7局',
            value: '7'
          },
          {
            val: '第8局',
            value: '8'
          },
          {
            val: '第9局',
            value: '9'
          }
        ]
      }
    };
  },
  mounted() { 
    console.log(this.data,'data');
    
  },
  methods: {
    basketball() {
      this.$emit('basketball')
      // this.$router.push({ path: '/match/football-data', query: { gameId: this.gameId } })
    },
    isLength(i) {
      let len = Object.keys(this.data[0].stats).length -1
      return i < len
    }
  },
};
</script>

<style scoped lang="scss">
div{
  box-sizing: border-box;
}
.box {
  padding: 10px 0;
  background-color: #fff;
  margin-top: 20px;
  .title {
    padding: 15px;
    font-size: 18px;
    span{
      color: #9B9B9B;
      font-size: 14px;
      float: right;
      margin-top: 3px;
    }
  }
  .data-box{
    display: flex;
  }
  .table-title{
    color: #fff;
    font-size: 12px;
    box-shadow: 4px 4px 6px 2px rgba(0,0,0,.06);
    width: var(--width);
    position: relative;
    z-index: 3;
    div{
      width: var(--width);
      height: 65px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      &:nth-child(2n){
        background-color: #F8F8F8;
      }
    }
    .name{
      background-color: #EC4E4E;
    }
  }
  .code{
    flex: 1;
    max-width: calc(100% - 86px);
    overflow: scroll;
    .code-title{
      min-width: 50px;
      width: 50px;
      height: 65px;
      font-size: 12px;
      font-weight: 500;
      color: #fff;
      padding: 5px 0px;
      background-color: #0D7096;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      text-align: center;
    }
    .for-data{
      display: flex;
      div{
        min-width: 50px;
        width: 50px;
        height: 65px;
        font-size: 12px;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &:nth-child(2n){
        div{
          background-color: #F8F8F8;
        }
      }
    }
  }
}
</style>
